export const DashboardCategory = {
  CONSUMER: 'consumer360',
  BRAND: 'brandDashboard',
  GROUP: 'groupDashboard',
  SEGMENT: 'segment'
}

export const DashboardSources = {
  DATASOURCE: 'dataSource',
  THIRD_PARTY: 'thirdParty',
  TAXONOMY: 'taxonomy',
  PII_TABLE: 'piiMappingTable',
  INDICATOR: 'indicator',
  FIRSTPARTY_TAXONOMY: 'taxonomy',
  THIRDPARTY_TAXONOMY: 'thirdPartyTaxonomy'
}

export const DashboardSettingType = {
  PII: 'pii',
  PROFILE: 'profile',
  FOOTPRINT: 'footPrint',
  SUMMARY: 'summary',
  CHART: 'chart',
  PIECHART: 'pieChart',
  BARCHART: 'barChart',
  LINECHART: 'lineChart',
  MAP: 'map',
  SANKEY: 'sankey',
  TIMELINE: 'timeline',
  CUSTOM: 'custom',
  TAGS: 'tags'
}

export const ChtType = {
  AGE: 'age',
  GENDER: 'gender',
  INTEREST: 'interest',
  WEBSITE: 'website',
  HOME: 'home',
  WORK: 'work',
  APP: 'app'
}

export const ContactType = {
  EMAIL: 'Email',
  LINE: 'Line',
  WHATSAPP: 'WhatsApp',
  INSTAGRAM: 'Instagram',
  FACEBOOK: 'Facebook',
  YOUTUBE: 'Youtube',
  TWITTER: 'Twitter',
  LINKEDIN: 'LinkedIn',
  TIKTOK: 'TikTok'
}

export const QueryExpression = {
  SELECT: 'SELECT',
  ORDERBY: 'ORDER BY',
  LIMIT: 'LIMIT',
  COUNT: 'COUNT',
  AVG: 'AVG',
  SUM: 'SUM',
  WHERE: 'WHERE',
  GROUPBY: 'GROUP BY'
}

export const DefaultColor = {
  1: '#449FBF',
  2: '#f6bd60',
  3: '#77D2BC',
  4: '#D69596',
  5: '#CF8E52',
  6: '#55AF77',
  7: '#83c5be',
  8: '#A489C7',
  9: '#54A4A0',
  10: '#e29578',
  11: '#e76f51',
  12: '#C2DCB9',
  13: '#a8dadc',
  14: '#457b9d',
  15: '#829ABC',
  16: '#fca311',
  17: '#bc6c25',
  18: '#606c38',
  19: '#6177F4',
  20: '#89867F'
}
